import React, {useContext, useEffect} from 'react';
import { ButtonProps } from '@material-ui/core/Button';
import { Theme } from '@material-ui/core';
import { useFormikContext } from 'formik';
import { createStyles, makeStyles } from '@material-ui/styles';

import { Button, ItemFormContext } from '..';
import hotKeyConverter from '../../utility/keyCodeConverter';

type Props = ButtonProps & {
  withHotkey?: boolean;
};

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {
    '&:hover': {
      backgroundColor: palette.buttonAction.background,
    },
  },
  disabled: palette.disabledButton,
}), { name: 'submit' });

const FormSubmit = ({
  children,
  disabled,
  withHotkey,
  classes,
  ...props
}: Props) => {
  const styles = useStyles();
  const formContext = useFormikContext();
  const { disableSubmit } = useContext(ItemFormContext);

  useEffect(() => {
    const hotKeyHandler = (event: KeyboardEvent) => {
      if (
        event.ctrlKey && event.keyCode === hotKeyConverter('s')
        && formContext.isValid && !formContext.isSubmitting && !disableSubmit
      ) {
        event.preventDefault();
        formContext.submitForm();
      }
    };
    if (withHotkey) {
      window.addEventListener('keydown', hotKeyHandler);
    }
    return () => {
      if (withHotkey) {
        window.removeEventListener('keydown', hotKeyHandler);
      }
    };
  }, [withHotkey, formContext, disableSubmit]);

  return (
    <Button
      disabled={!formContext.isValid || disabled || disableSubmit}
      type="submit"
      classes={{
        ...styles,
        ...classes,
      }}

      {...props}
    >
      {children}
    </Button>
  );
};

export default FormSubmit;
